import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { solarPaybackSelectorKey } from './store';
import { solarPaybackReducer } from './store/solar-payback.reducer';
import { SolarPaybackEffects } from './store/solar-payback.effects';
import { SolarPaybackUsageEstimateFormSubmitEffects } from './store/usage-estimate-form-submit.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(solarPaybackSelectorKey, solarPaybackReducer),
    EffectsModule.forFeature([
      SolarPaybackEffects,
      SolarPaybackUsageEstimateFormSubmitEffects,
    ]),
  ],
})
export class SolarPaybackBootstrapModule {}
